<template>
<div style="height: 300px;overflow-y: scroll;position: relative;">

  <div style="position: sticky;left: 0;top: 0;z-index: 2;">
    <el-input
      placeholder="输入关键字进行过滤"
      v-model="filterText">
    </el-input>
  </div>

  <el-tree
    ref="tree"
    :props="props"
    :load="loadNode"
    node-key="id"
    lazy
    :highlight-current="true"
    :expand-on-click-node="false"
    :filter-node-method="filterNode"
    @node-click="nodeClick"
    @check="check"
    :default-checked-keys="default_checked_keys"
    :show-checkbox="isCheckbox">
  </el-tree>
</div>
</template>

<script>
import MeterHttp from "../../../common/MeterHttp";

export default {
  name: "MeterTree",
  props:{
    isCheckbox:{type:Boolean,default:()=>false},
    project_id: {type:Number|String,default:()=>0},
    checked_keys:{type:String|Number,default:()=>''},
  },
  data() {
    return {
      props: {
        label: 'meter_name',
        children: 'zones',
        isLeaf: 'leaf'
      },
      filterText:"",
      default_checked_keys:[]
    };
  },
  mounted() {

  },
  methods: {
    loadNode(node, resolve) {
      const that=this;
      if (node.level === 0) {
        that.getData(0,ret=>{
          resolve(ret);
          that.reSelect();
          that.$emit('onNodeList',ret)
        })
        return false;
      }
      that.getData(node.data.id,ret=>{
        resolve(ret);
      })
    },
    getData(id,callback){
      MeterHttp.get("Meter/getParentSon?user_type="+(this.$route.query.type||0),{
        id:id,
        project_id:this.project_id,
      },ret=>{
        if(ret.code){
          callback(ret.data);
        }else {
          callback([])
        }
      })
    },
    reSelect(){
      if(this.checked_keys){
        let checked_keys=((this.checked_keys||"")+"").split(',').map(id=>id*1);
        if(checked_keys.length){
          this.default_checked_keys=checked_keys
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.meter_name.indexOf(value) !== -1;
    },
    nodeClick(data){
      if(!this.isCheckbox){
        this.$emit('onNode',data)
      }
    },
    check(data){
      if(this.isCheckbox){
        let check_nodes=this.$refs.tree.getCheckedNodes()
        this.$emit('onNode',check_nodes)
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/MeterTree.vue